import { useMemo } from "react";
import { LoadSettingAck } from "../../store/backend";

export type FanSpeedInfoTooltipProps = {
  isOpen?: boolean;
  fanSpeedMode: LoadSettingAck['data']['fanSpeedMode']
  style?: React.CSSProperties
};


const getModeInfo = (mode: FanSpeedInfoTooltipProps['fanSpeedMode']) => {
  switch (mode) {
    case 'HIGH': {
      return {
        title: 'HIGH FAN SPEED',
        content: `Fan speed set to maximum airflow.
        Most efficient air circulation with quickest heating and cooling.`,
      }
    }
    case 'MEDIUM': {
      return {
        title: 'MEDIUM FAN SPEED',
        content: `Fan speed set to moderate airflow. 
        A balance of air circulation and performance.`,
      }
    }
    case 'LOW': {
      return {
        title: 'LOW FAN SPEED',
        content: `Fan speed set to low airflow. 
        Heating and cooling will take longer time to reach target temperatures`,
      }
    }
    case 'MIN': {
      return {
        title: 'MINIMUM FAN SPEED',
        content: `Fan speed set to minimum airflow.
        Fans stop completely after heating or cooling cycles allowing very gentle air circulation.`,
      }
    }

    default: {
      return {
        title: 'MINIMUM FAN SPEED',
        content: `Fan speed set to minimum airflow.
        Fans stop completely after heating or cooling cycles allowing very gentle air circulation.`,
      }
    }

  }
}



function FanSpeedInfoTooltip(props: FanSpeedInfoTooltipProps) {

  const info = useMemo(() => {
    return getModeInfo(props.fanSpeedMode)
  }, [props.fanSpeedMode])

  if (!props.isOpen) {
    return <div />;
  }

  return (
    <div
      className="flex"
      style={{
        flexDirection: 'column',
        position: 'absolute',
        alignItems: "center",
        zIndex: 20000,
        height: 270,
        width: 600,
        borderRadius: 25,
        overflow: 'hidden',
        padding: '35px 45px',
        backgroundColor: '#D9D9D9',
        left: 75,
        top: 160,
        boxShadow: "8px 8px 8px  rgba(0, 0, 0, 0.4)",
        ...props.style || {},
      }}
    >
      <div
        style={{
          fontSize: 32,
          fontWeight: 'bold',
          marginBottom: 20,
        }}
      >
        {info.title}
      </div>
      <div
        style={{
          fontSize: 24,
          textAlign: 'center',
          whiteSpace: 'pre-line',   // 这个会根据字符串自动换行
        }}
      >
        {info.content}
      </div>
    </div>
  );
}

export default FanSpeedInfoTooltip;
